import { CombinedError } from "urql";

import { reportError } from "@/utils/errors";

const getGraphqlErrorCodes = (error: unknown) => {
    const errorCodes: string[] = [];

    try {
        const graphqlErrors = [...((error as CombinedError)?.graphQLErrors ?? [])];

        graphqlErrors.forEach(error => {
            if (typeof error?.extensions?.code === "string") {
                errorCodes.push(error.extensions.code);
            }
        });
    } catch (error) {
        reportError(error, "getGraphqlErrorCodes");
    }

    return errorCodes;
};

export function hasGraphqlError(error: unknown, errorCode: string) {
    return getGraphqlErrorCodes(error).includes(errorCode);
}
